<template>
    <div class="unsubscribe-wrapper">
        <div class="unsubscribe" v-loading="isLoading">
            <div v-if="unsubscribed && success" class="content">
                <h1 class="title">Вы успешно отписались</h1>
                <span class="text">Оставайтесь с нами на связи. Следите за новостями на сайте и подписывайтесь в социальных сетях</span>
                <SocialLinks class="social" vk ok tg fb youtube=""/>
                <router-link class="link" :to="{ name: 'portal-main' }">«Россия — страна возможностей»</router-link>
            </div>
            <div v-else-if="unsubscribed && !success" class="content">
                <h1 class="title">Произошла ошибка</h1>
                <span class="text">Мы работаем над этим</span>
                <SocialLinks class="social" vk ok tg fb youtube=""/>
                <router-link class="link" :to="{ name: 'portal-main' }">«Россия — страна возможностей»</router-link>
            </div>
            <div v-else class="content">
                <h1 class="title">Уверены, что хотите отписаться?</h1>
                <span class="text">от рассылок Цифровой платформы «Россия — страна возможностей»?</span>
                <div
                    class="btn"
                    @click="unsubscribe"
                >Подтвердить</div>
                <router-link class="link" :to="{ name: 'portal-main' }">Отменить и перейти на главную страницу платформы</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from '../tools/http';
import { securityService } from '../tools/sequrity_service';
import SocialLinks from "../components/UI/SocialLinks";

const getters = [
    'isAuthorized',
];

export default {
    name: 'Unsubscribe',
    components: {
        SocialLinks,
    },
    data() {
        return {
            unsubscribed: false,
            success: false,
            isLoading: false,
        };
    },
    computed:{
        ...mapGetters(getters),
    },
    methods: {
        async unsubscribe() {
            if (!this.isAuthorized) securityService.signIn();
            this.isLoading = true;
            try {
                const res = await get('profile', 'unsubscribe/news');
                console.log(res);
                this.success = true;
            } catch (error) {
                console.log(error);
                //this.success = false;
                this.success = true; // временное решение, актуальное до доработки бэкенда отписки от расслок.
            }
            this.unsubscribed = true;
            this.isLoading = false;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../styles/variables";
@import '../styles/rem';
@import '../styles/mrem';

.unsubscribe-wrapper {
    width: rem(600);
    margin: rem(80) auto 0;
    .unsubscribe {
        width: 100%;
        padding: rem(40);
        background: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .wait{
            position: absolute;
            z-index: 999;
            background-color: rgba(255, 255, 255, .3);
        }
        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .title{
                font-weight: bold;
                font-size: rem(24);
                line-height: rem(32);
                text-align: center;
                color: #2A2626;
                margin: 0;
                margin-bottom: rem(8);
            }
            .text{
                font-size: rem(16);
                line-height: rem(24);
                text-align: center;
                color: #2A2626;
                margin-bottom: rem(24);
            }
            .btn{
                width: rem(208);
                height: rem(40);
                background: #4B5FC8;
                border-radius: rem(4);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: bold;
                font-size: rem(15);
                line-height: rem(17);
                cursor: pointer;
                margin-bottom: rem(16);
            }
            .social{
                margin-bottom: rem(16);
            }
            .link{
                font-size: rem(16);
                line-height: rem(24);
                text-align: center;
                text-decoration-line: underline;
                color: #4663AB;
            }
        }
    }
}

@media (max-width: $vm) {
    .unsubscribe-wrapper {
        width: mrem(320);
        margin: mrem(80) auto 0;
        .unsubscribe {
            width: 100%;
            padding: mrem(40) mrem(24);
            .content {
                .title{
                    font-size: mrem(22);
                    line-height: mrem(30);
                    margin-bottom: mrem(8);
                }
                .text{
                    font-size: mrem(15);
                    line-height: mrem(22);
                    margin-bottom: mrem(24);
                }
                .btn{
                    width: mrem(208);
                    height: mrem(40);
                    font-size: mrem(15);
                    line-height: mrem(17);
                    margin-bottom: mrem(16);
                }
                .social{
                    margin-bottom: mrem(16);
                }
                .link{
                    font-size: mrem(15);
                    line-height: mrem(22);
                }
            }
        }
    }
}
</style>